import {PipelineStepType} from 'graphql-client/__generated/graphqlGlobalTypes';

import {StepTypeConfigUISchemaV2} from '../step-config-settings/StepConfigUISchemas';
import {FIELD_ORDER_UI_SCHEMA_KEY} from '../StepConfigEditorTypes';

export const DATA_CATALOG_DATASET_V0_UI_SCHEMA: StepTypeConfigUISchemaV2<
  PipelineStepType.DATA_CATALOG_DATASET,
  0
> = {
  [FIELD_ORDER_UI_SCHEMA_KEY]: ['datasetId', 'dataFrameName'],
  datasetId: {displayName: 'Dataset', configShapePath: ['datasetId']},
  dataFrameName: {displayName: 'Table name', configShapePath: ['dataFrameName']},
};
